import React from 'react';
import Navbar from '../components/Navbar';
import { motion } from 'framer-motion';
import { CheckCircle } from 'lucide-react';

const Solutions = () => {
  const solutions = [
    {
      title: 'Acoperș Înclinat',
      description: 'Sistem complet de izolații pentru acoperșuri înclinate cu diverse pante',
      features: ['Membrane bituminoase', 'Termoizolație', 'Protecție UV', 'Rezistență la intemperii'],
      image: 'https://images.unsplash.com/photo-1609588959666-3cb46cabe3f7?crop=entropy&cs=srgb&fm=jpg&q=85'
    },
    {
      title: 'Acoperș Plat',
      description: 'Soluții tehnice pentru acoperșuri plane cu drenaj eficient',
      features: ['Hidroizolații bituminoase', 'Membrane sintetice', 'EPDM', 'Sistem de pantare'],
      image: 'https://images.unsplash.com/photo-1563174499-83c108efd397?crop=entropy&cs=srgb&fm=jpg&q=85'
    },
    {
      title: 'Acoperș Verde',
      description: 'Sisteme ecologice cu vegetație pentru acoperșuri durabile',
      features: ['Strat vegetal', 'Sistem drenaj', 'Protecție rădăcini', 'Izolație termică'],
      image: 'https://images.unsplash.com/photo-1712153191094-50682c5bea14?crop=entropy&cs=srgb&fm=jpg&q=85'
    },
    {
      title: 'Izolații Balcoane',
      description: 'Sistem special pentru izolarea și impermeabilizarea balcoanelor',
      features: ['Hidroizolații', 'Termoizolații', 'Finisaje rezistente', 'Protecție la umiditate'],
      image: 'https://images.unsplash.com/photo-1688142818737-65f8bebb4d03?crop=entropy&cs=srgb&fm=jpg&q=85'
    },
    {
      title: 'Termo-Hidroizolare Fundații',
      description: 'Protecție completă pentru fundații împotriva umidității și pierderilor termice',
      features: ['Membrane hidroizolante', 'Polistiren extrudat', 'Protecție mecanică', 'Rezistență la presiune'],
      image: 'https://images.unsplash.com/photo-1489514354504-1653aa90e34e?crop=entropy&cs=srgb&fm=jpg&q=85'
    },
    {
      title: 'Izolații Bazine',
      description: 'Sisteme speciale pentru bazine de stocare apă și PSI',
      features: ['Rezistență chimică', 'Impermeabilizare totală', 'Membrane speciale', 'Certificare pentru apă potabilă'],
      image: 'https://images.unsplash.com/photo-1681049400158-0ff6249ac315?crop=entropy&cs=srgb&fm=jpg&q=85'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-cyan-50" data-testid="solutions-page">
      <Navbar />
      
      <div className="pt-24 pb-12 px-4">
        <div className="max-w-7xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-12"
          >
            <h1 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }} data-testid="solutions-title">
              Soluții Tehnice
            </h1>
            <p className="text-lg text-slate-600">Sisteme complete de izolații pentru fiecare tip de construcție</p>
          </motion.div>

          <div className="space-y-12">
            {solutions.map((solution, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className={`glass-card overflow-hidden ${
                  index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'
                } flex flex-col lg:flex`}
                data-testid={`solution-${index}`}
              >
                <div className="lg:w-1/2">
                  <img
                    src={solution.image}
                    alt={solution.title}
                    className="w-full h-64 lg:h-full object-cover"
                  />
                </div>
                <div className="lg:w-1/2 p-8 lg:p-12">
                  <h2 className="text-3xl font-bold text-slate-900 mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
                    {solution.title}
                  </h2>
                  <p className="text-lg text-slate-600 mb-6">{solution.description}</p>
                  <div className="space-y-3">
                    {solution.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center space-x-3">
                        <CheckCircle className="w-5 h-5 text-lime-500 flex-shrink-0" />
                        <span className="text-slate-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Solutions;
